import React from "react";
import { List } from "../modules/TransactionsBiller";

export function TransactionsBillerPage(props) {
  return <List {...props} />;
}
